export const DETALHE_TITLE = "Detalhes do Escopo macro";
export const FECHAR_LABEL = "Fechar";
export const EDITAR_LABEL = "Editar";
export const EDITAR_MOTIVO = "Disponível com a projeção financeira";
export const CARREGANDO_LABEL = "Carregando escopo macro...";
export const CAMPO_NOME = "Nome do Escopo Macro";
export const CAMPO_ORIGEM = "Origem";
export const CAMPO_REFERENCIA_MENSALIZACAO = "Referência da mensalização";
/** D-156: a mensalização ancora nas datas da Obra (Figma 16417:421252). */
export const DATAS_DA_OBRA_PREFIXO = "Datas da Obra:";
export const PROJECAO_TITLE = "Projeção financeira";
export const SERVICOS_TITLE = "Serviços";
export const MATERIAIS_TITLE = "Materiais";
export const TOTAL_ESCOPO_TITLE = "Valor total do escopo macro";
export const DISTRIBUICAO_TITLE = "Distribuição por coletor e mensalização";
export const COLETOR_COLUNA = "Coletor";
export const TOTAL_COLUNA = "Total (R$)";
export const TOTAL_GERAL = "Total geral";
export const TABELA_LABEL = "Distribuição por coletor";
/** Figma 16419:428022; o prefixo e os meses vêm do escopo aberto (`103`, `mar/27`, `abr/27`). */
export const NOTA_TABELA = (tipoCodigo: string, inicio: string, fim: string) =>
  `Coletores com o prefixo do Tipo de Obra do escopo (${tipoCodigo}). Meses ancorados no início (${inicio}) e no término (${fim}) da Obra: a fase Antes das curvas cai nos meses anteriores e a fase Após, nos seguintes. As datas previstas do escopo não mudam a mensalização. Valores em reais, já com o fator de idade.`;
export const SUFIXO_INICIO = " · Início";
export const SUFIXO_FIM = " · Fim";
export const NO_VALUE = "—";
/** Figma 16417:421264 (3a, escopo sem projeção). */
export const SEM_PROJECAO = "Pendente";
export const SEM_PROJECAO_AVISO =
  "Este escopo macro ainda não tem projeção financeira e não entra nos totais da Obra. Clique em Editar para preencher.";
export const NAO_INFORMADO = "Não informado";
export const NAO_DEFINIDA = "Não definida";
export const SEM_PROJECAO_COLETORES =
  "Sem projeção financeira: os valores por coletor e a mensalização aparecem depois que a projeção for preenchida.";
/** Figma 16419:430421 (2d). */
export const CLASSIFICACAO_PENDENTE = "Classificação pendente";
/** Figma 16417:421258 (Tipo 100, sem fator de idade). */
export const FATOR_NAO_APLICADO = "Fator de idade: não aplicado";
export const ROTULO_CC_PRINCIPAL = "Centro de custo principal";
export const COTACAO_TITLE = "Cotação da Obra";
export const COTACAO_NOTA =
  "Vale para todos os escopos e Facilidades desta Obra. Para alterar, use a Cotação da Obra no Planejamento e Controle.";
